import { ReactNode, useCallback, useEffect } from 'react'
import { navigate } from 'gatsby'
import { useDispatch } from 'react-redux'
import { useLocation } from '@reach/router'
import { sagaActions } from 'store/sagas/typeSagas'
import { useAuth0 } from 'lib/auth'
import { useCustomerQuery } from 'lib/graphql/storefront'
import store from 'store/store'
import * as config from 'config'

export interface SessionCheckProps {
  children?: ReactNode
}

// セッションチェック
const SessionCheck = ({ children }: SessionCheckProps): JSX.Element => {
  const dispatch = useDispatch()
  const { isAuthenticated, isLoading, getAccessTokenSilently, user } =
    useAuth0()
  const { auth } = store.getState()
  const { data: customerData, loading: customerLoading } = useCustomerQuery()
  const { pathname } = useLocation()

  const getAccessToken = useCallback(async () => {
    try {
      const accessToken = await getAccessTokenSilently({
        audience: config.auth0.audience,
      })
      dispatch({
        type: sagaActions.UPDATE_ACCESS_TOKEN,
        payload: accessToken,
      })
    } catch (e) {
      console.error(e)
    } finally {
      // Do nothing
    }
  }, [dispatch, getAccessTokenSilently])

  useEffect(() => {
    if (isLoading) return

    if (isAuthenticated === true) {
      getAccessToken()
    } else if (isAuthenticated === false) {
      dispatch({ type: sagaActions.CLEAR_TOKENS })
    } else {
      // Do nothing
    }
  }, [isAuthenticated, isLoading, dispatch, getAccessToken])

  // セッション管理をしないパス
  const canAccessDirect = (): boolean => {
    const routesAccessDirect = [
      '/faq',
      '/inquires',
      '/privacy',
      '/term-of-service',
      '/bookings/calendar',
    ]
    return routesAccessDirect.includes(pathname)
  }

  useEffect(() => {
    const { accessToken: isLoggedIn } = auth
    const isMailVerified = user?.emailVerified
    const hasCustomerAddress = !!customerData?.customer?.address

    // ログイン済みの場合抑制判断処理する
    // ログインした後の画面遷移の流れ：
    // auth0 login pgae -> 検証されてない・addressがない場合　-> 各自に対応する page へ redirect する
    // auth0 login pgae -> 検証済み・addressもある場合　-> /callback へ redirect する
    if (!!isLoggedIn && !!user && !customerLoading && !canAccessDirect()) {
      // email address の検証が出来ていない場合は以下のページへ遷移
      if (!isMailVerified) {
        navigate(`/unverified-email`, { replace: true })
      }
      //  data がなければページ遷移させ、あればそのまま
      if (isMailVerified && !hasCustomerAddress) {
        navigate('/contact-information', { replace: true })
      }
    }
    // 関数 canAccessDirect を依頼リストに入れたら無限ループrenderになってしまうので、disabledにする
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth?.accessToken,
    user?.emailVerified,
    customerLoading,
    customerData?.customer?.address,
  ])

  return <>{children}</>
}

export default SessionCheck

// TODO coming soon 期間終了後、ここより上のコードのコメントを外す
// TODO coming soon 期間終了後、ここより下のコードを削除する（開発でcoming soonを外したい場合は、削除ではなく、コメントアウトしてください）

// import { ReactNode, useCallback, useEffect } from 'react'
// import { navigate } from 'gatsby'
// import { useDispatch } from 'react-redux'
// import { useLocation } from '@reach/router'
// import { sagaActions } from 'store/sagas/typeSagas'
// import { useAuth0 } from 'lib/auth'
// import * as config from 'config'

// export interface SessionCheckProps {
//   children?: ReactNode
// }

// const SessionCheck = ({ children }: SessionCheckProps): JSX.Element => {
//   const dispatch = useDispatch()
//   const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()
//   const { pathname } = useLocation()

//   const getAccessToken = useCallback(async () => {
//     try {
//       const accessToken = await getAccessTokenSilently({
//         audience: config.auth0.audience,
//       })
//       dispatch({
//         type: sagaActions.UPDATE_ACCESS_TOKEN,
//         payload: accessToken,
//       })
//     } catch (e) {
//       console.error(e)
//     } finally {
//       // Do nothing
//     }
//   }, [dispatch, getAccessTokenSilently])

//   useEffect(() => {
//     if (isLoading) return

//     if (isAuthenticated) {
//       getAccessToken()
//     } else {
//       dispatch({ type: sagaActions.CLEAR_TOKENS })
//     }
//   }, [isAuthenticated, isLoading, dispatch, getAccessToken])

//   // coming soon 期間中にアクセス可能なページかどうかを判断する
//   const isAccessiblePage = (): boolean => {
//     if (pathname === '/') return false

//     const routesAccessible = [
//       '/faq/',
//       '/inquires/',
//       '/privacy/',
//       '/term-of-service/',
//       '/coming-soon/',
//     ]
//     return routesAccessible.includes(pathname)
//   }
//   const isAccessible = isAccessiblePage()

//   useEffect(() => {
//     if (!isAccessible) {
//       navigate('/coming-soon/', { replace: true })
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isAccessible])

//   return <>{isAccessible && children}</>
// }

// export default SessionCheck
